import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Popconfirm,Popover,
  Collapse,Avatar,Drawer,Descriptions,message,Modal,Spin,Switch} from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,FundOutlined,FundViewOutlined,DeleteOutlined,LockFilled,LockOutlined,LoadingOutlined } from '@ant-design/icons';
import { UserOutlined } from '@ant-design/icons';
import { Form,Select,Checkbox,Upload } from 'antd';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import PortalUserForm from '../components/PortalUserForm'

var CryptoJS = require("crypto-js");
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const { Panel } = Collapse;
const FormItem=Form.Item;

function callback(key) {
  console.log(key);
}

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var sacco= ''
var username=''
var token= ''
var ngoid= ''

class PortalUserList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    portal_users: [],
    showpasswordupdatemodal:false,
    selectedid:''
   
  };

  
  //////////////////////////////////////
  ///// change password here





  componentDidMount(){

    if(localStorage.getItem("username")){
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/portal_users/`)
    .then(res => {
        this.setState({
          portal_users:res.data
        })

        this.setState({datarequested:false})

    })

}


  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const columns = [
      
      {
        title: 'Email',
        dataIndex: 'client_email',
        key: 'id',
        ...this.getColumnSearchProps('client_email'),
      },
      {
        title: 'Date Of Creation',
        dataIndex: 'date_of_creation',
        key: 'id',
        ...this.getColumnSearchProps('date_of_creation'),
      },
      {
        title: 'Last Login',
        dataIndex: 'last_login',
        key: 'last_login',
      },
      {
        title: 'Sur Name',
        dataIndex: 'sur_name',
        key: 'id',
        ...this.getColumnSearchProps('sur_name'),
      },

      {
        title: 'Other Name',
        dataIndex: 'other_name',
        key: 'id',
        ...this.getColumnSearchProps('other_name'),
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'id',
        ...this.getColumnSearchProps('phone'),
      },

      {
        title: 'Last login',
        dataIndex: 'last_login',
        key: 'id',
      },
      
      {
        title: 'Actions',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
       
        <Popover 
        content={<p>Click to change password</p>} 
        title="Password Change">
          <LockFilled 
           style={{color:'#154360'}}
           onClick={() => {
            this.setState({selectedid:record.id})
            this.setState({showpasswordupdatemodal:true})

           }}/>
        </Popover>
        </p>,
      },

    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>       
        </div>
      )

    }else{

      return(
        <div>
           <Collapse defaultActiveKey={['1']} onChange={()=>{}}>
            <Panel header="ALL PORTAL ACCOUNTS" key="1">
            <Table 
             scroll={{ x: 1000 }}
             columns={columns}
             pagination={{showQuickJumper:true,showSizeChanger:true }}
             dataSource={this.state.portal_users} bordered/>
            </Panel>
            </Collapse>

            <br></br>
            <PortalUserForm />



            <Modal              
                visible={this.state.showpasswordupdatemodal}
                title="Password change Form"
                width={600}
                onCancel={()=>{this.setState({showpasswordupdatemodal:false})}}

                footer={[
                  <Button key="back" onClick={()=>{this.setState({showpasswordupdatemodal:false})}}>
                    Cancel
                  </Button>
                  ]}
                  >
              <Form
               onFinish={
                (values)=>{
                  this.setState({datarequested:true})
              
                  let form_data = new FormData();
                  form_data.append('password1', values.new_password1);
                  form_data.append('password2', values.new_password2);
                  form_data.append('userid', this.state.selectedid);
                
                  //Now send the post resquest
                    axios.post(serverconfig.backendserverurl+'/customqueries/update_portaluserpassword', form_data, {
                    headers: {
                      'content-type': 'multipart/form-data'
                    }
                    })
                  .then(res => {
                    this.setState({datarequested:false})
                    message.info(res.data.message);
                    this.setState({showpasswordupdatemodal:false})
                  }
                  )
                  .catch(error => console.log(error)) 
                
                }
             

              }        
              name="passwordreset"
              className="login-form">
        
              <Form.Item
                  name="new_password1"
                  label="New Password one"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password 
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Password one"
                  />


                </Form.Item>

          
                <Form.Item
                  name="new_password2"
                  label="Confirm New Password"
                  dependencies={['new_password1']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue('new_password1') === value) {
                          return Promise.resolve();
                        }
          
                        return Promise.reject('The two passwords that you entered do not match!');
                      },
                    }),
                  ]}
                >
                  <Input.Password 
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Confirm" />

                </Form.Item>

              <Form.Item >
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    Confirm Change
                  </Button>
              </Form.Item>
            </Form>
                    
            </Modal>



        </div>
    )
    }
   
  }
}

export default PortalUserList; 
